import * as React from 'react';

import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

export const dateLastUpdated = () => {
	const currentYear = new Date().getFullYear();
	const currentDate = new Date();
	const lastUpdated = new Date(`1 March ${currentYear}`);

	let newLastUpdated = '';

	if (currentDate > lastUpdated) {
		newLastUpdated = `March ${currentYear}`;
	}

	if (currentDate < lastUpdated) {
		newLastUpdated = `March ${currentYear - 1}`;
	}

	return newLastUpdated;
};

const PrivacyPolicy = () => {
	return (
		<div className="policies">
			<div className="middle-text__text">
				<p>
					<b>{dateLastUpdated()}</b>
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use
					the Service and tells You about Your privacy rights and how the law protects You.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of
					information in accordance with this Privacy Policy.
				</p>
			</div>
			<h2>INTERPRETATION AND DEFINITIONS</h2>
			<h4 className="middle-text__title">Interpretation</h4>
			<div className="middle-text__text">
				<p>
					The words of which the initial letter is capitalized have meanings defined under the following conditions. The following
					definitions shall have the same meaning regardless of whether they appear in singular or in plural.
				</p>
			</div>
			<div className="middle-text__text">
				<p>For the purposes of this Privacy Policy: </p>
			</div>
			<div className="middle-text__text">
				<ul>
					<li>
						<b>Account</b> means a unique account created for You to access our Service or parts of our Service.
					</li>
					<li>
						<b>Company</b> (referred to as either “Company”, “We”, “Us”, or “Our” in this Agreement) refers to Lap of Love, 17804 US
						Highway 41 North, Lutz, Florida 33549.
					</li>
					<li>
						<b>Cookies</b> are small files that are placed on Your computer, mobile device, or any other device by a website, containing
						the details of Your browsing history on that website among its many uses.
					</li>
					<li>
						<b>Country</b> refers to: Florida, United States
					</li>
					<li>
						<b>Device</b> means any device that can access the Service such as a computer, a cellphone, or a digital tablet.
					</li>
					<li>
						<b>Personal Data</b> is any information that relates to an identified or identifiable individual.
					</li>
					<li>
						<b>Service</b> refers to the Website.
					</li>
					<li>
						<b>Service Provider</b> means any natural or legal person who processes the data on behalf of the Company. It refers to
						third-party companies or individuals hired by the Company to facilitate the Service, to provide the Service on behalf of the
						Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.
					</li>
					<li>
						<b>Third-party Social Media Service</b> refers to any website or any social network website through which a User can log in or
						create an account to use the Service.
					</li>
					<li>
						<b>Usage Data</b> refers to data collected automatically, either generated by the use of the Service or from the Service
						infrastructure itself (for example, the duration of a page visit).
					</li>
					<li>
						<b>Website</b> refers to Lap of Love, accessible from{' '}
						<a href={'https://www.lapoflove.com'} className={'inline-link'}>
							https://www.lapoflove.com
						</a>
						.
					</li>
					<li>
						<b>You</b> means the individual accessing or using the Service, or the company or other legal entity on behalf of which such
						individual is accessing or using the Service, as applicable.
					</li>
				</ul>
			</div>

			<h2>COLLECTING AND USING YOUR PERSONAL DATA</h2>
			<h4 className="middle-text__title">Types of Data Collected</h4>
			<h4 className="middle-text__title">Personal Data</h4>

			<div className="middle-text__text">
				<p>
					While using Our Service, We may ask You to provide Us with certain information that can be used to contact or identify You. Such
					Personal Data may include, but is not limited to:
				</p>
			</div>

			<div className="middle-text__text">
				<ul>
					<li>Email address</li>
					<li>First name and last name</li>
					<li>Phone number</li>
					<li>Address, State, Province, ZIP/Postal code, City</li>
					<li>Usage Data</li>
				</ul>
			</div>

			<h4 className="middle-text__title">Usage Data</h4>

			<div className="middle-text__text">
				<p>Usage Data is collected automatically when using the Service.</p>
			</div>

			<div className="middle-text__text">
				<p>
					Usage Data may include information such as Your Device's Internet Protocol address (IP address), browser type, browser version,
					the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers
					and other diagnostic data.
				</p>
			</div>

			<div className="middle-text__text">
				<p>
					When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not
					limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile
					operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
				</p>
			</div>

			<div className="middle-text__text">
				<p>
					We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or
					through a mobile device.
				</p>
			</div>
			<h4 className="middle-text__title">Tracking Technologies and Cookies</h4>

			<div className="middle-text__text">
				<p>
					We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking
					technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The
					technologies We use may include:
				</p>
			</div>

			<div className="middle-text__text">
				<ul>
					<li>
						<b>Cookies or Browser Cookies.</b> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all
						Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some
						parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use
						Cookies.
					</li>
					<li>
						<b>Flash Cookies.</b> Certain features of our Service may use local stored objects (or Flash Cookies) to collect and store
						information about Your preferences or Your activity on our Service. Flash Cookies are not managed by the same browser settings
						as those used for Browser Cookies. For more information on how You can delete Flash Cookies, please read “Where can I change
						the settings for disabling, or deleting local shared objects?” available at{' '}
						<a
							href="https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_"
							className="inline-link"
						>
							https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_
							Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_
						</a>
					</li>
					<li>
						<b>Web Beacons.</b> Certain sections of our Service and our emails may contain small electronic files known as web beacons
						(also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who
						have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of
						a certain section and verifying system and server integrity).
					</li>
				</ul>
			</div>
			<div className="middle-text__text">
				<p>
					Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go
					offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies:{' '}
					<a href="https://www.privacypolicies.com/blog/cookies/" className="inline-link">
						What Are Cookies?
					</a>
					.
				</p>
			</div>
			<div className="middle-text__text">
				<p>We use both Session and Persistent Cookies for the purposes set out below:</p>
			</div>

			<div className="middle-text__text">
				<ul>
					<li>
						Necessary / Essential Cookies
						<ul>
							<li>Type: Session Cookies</li>
							<li>Administered by: Us</li>
							<li>
								Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to
								use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these
								Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with
								those services.
							</li>
						</ul>
					</li>
					<li>
						Cookies Policy / Notice Acceptance Cookies
						<ul>
							<li>Type: Persistent Cookies</li>
							<li>Administered by: Us</li>
							<li>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</li>
						</ul>
					</li>
					<li>
						Functionality Cookies
						<ul>
							<li>Type: Persistent Cookies</li>
							<li>Administered by: Us</li>
							<li>
								Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login
								details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to
								avoid You having to re-enter your preferences every time You use the Website.
							</li>
						</ul>
					</li>
				</ul>
			</div>
			<div className="middle-text__text">
				<p>
					For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies
					section of our Privacy Policy.
				</p>
			</div>

			<h4 className="middle-text__title">Use of Your Personal Data</h4>
			<div className="middle-text__text">
				<p>The Company may use Personal Data for the following purposes:</p>
			</div>

			<div className="middle-text__text">
				<ul>
					<li>
						<b>To provide and maintain our Service</b>, including to monitor the usage of our Service.
					</li>
					<li>
						<b>To manage Your Account:</b> to manage Your registration as a user of the Service. The Personal Data You provide can give
						You access to different functionalities of the Service that are available to You as a registered user.
					</li>
					<li>
						<b>For the performance of a contract:</b> the development, compliance and undertaking of the purchase contract for the
						products, items, or services You have purchased or of any other contract with Us through the Service.
					</li>
					<li>
						<b>To contact You:</b> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication,
						such as a mobile application's push notifications regarding updates or informative communications related to the
						functionalities, products, or contracted services, including the security updates, when necessary or reasonable for their
						implementation.
					</li>
					<li>
						<b>To provide You</b> with news, special offers and general information about other goods, services, and events which we offer
						that are similar to those that you have already purchased or inquired about unless You have opted not to receive such
						information.
					</li>
					<li>
						<b>To manage Your requests:</b> To attend and manage Your requests to Us.
					</li>
					<li>
						<b>For business transfers:</b> We may use Your information to evaluate or conduct a merger, divestiture, restructuring,
						reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of
						bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets
						transferred.
					</li>
					<li>
						<b>For other purposes:</b> We may use Your information for other purposes, such as data analysis, identifying usage trends,
						determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services,
						marketing, and your experience.
					</li>
					<li>
						<strong>SMS Text Messaging:</strong> You may opt in to receiving text messages, which we send through a third-party service
						provider. Depending on your interactions with the Company, we may contact you for various purposes, including but not limited
						to:
						<ul>
							<li>Notifications related to your pet’s or client’s services including appointment reminders and updates</li>
							<li>After-Care information</li>
							<li>Information on other available Company services</li>
							<li>Career opportunities</li>
							<li>Other communications related to your interactions online or via phone</li>
						</ul>
						To opt-out of text messages, simply reply "OPT OUT" to any message you receive from the Company. Please note that standard
						message and data rates may apply. No mobile information will be shared with third parties/affiliates for marketing/promotional
						purposes. All other categories exclude text messaging originator opt-in data and consent; this information will not be shared
						with any third parties. For more assistance, please email the Support Center at
						{' '}
						<a href="mailto:Support@LapofLove.com">Support@LapofLove.com</a>.
					</li>
				</ul>
			</div>

			<h4 className="middle-text__title">Disclosure of Your Personal Data</h4>
			<div className="middle-text__text">
				<i>Service Providers</i>
			</div>
			<div className="middle-text__text">
				<p>We may share Your personal information with Service Providers to monitor and analyze the use of our Service or, to contact You.</p>
			</div>
			<div className="middle-text__text">
				<i>Business Transactions</i>
			</div>
			<div className="middle-text__text">
				<p>
					If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice
					before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
				</p>
			</div>
			<div className="middle-text__text">
				<i>Affiliates and Business Partners</i>
			</div>
			<div className="middle-text__text">
				<p>
					We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy.
					Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or
					that are under common control with Us. We may also share Your information with Our business partners to offer You certain
					products, services, or promotions.
				</p>
			</div>
			<div className="middle-text__text">
				<i>Law Enforcement</i>
			</div>
			<div className="middle-text__text">
				<p>
					Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response
					to valid requests by public authorities (a court or a government agency).
				</p>
			</div>
			<div className="middle-text__text">
				<i>Other Legal Requirements</i>
			</div>

			<div className="middle-text__text">
				<p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
			</div>

			<div className="middle-text__text">
				<ul>
					<li>Comply with a legal obligation</li>
					<li>Protect and defend the rights or property of the Company</li>
					<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
					<li>Protect the personal safety of Users of the Service or the public</li>
					<li>Protect against legal liability</li>
				</ul>
			</div>

			<div className="middle-text__text">
				<i>Consent</i>
			</div>
			<div className="middle-text__text">
				<i>We may disclose Your personal information for any other purpose with Your consent.</i>
			</div>
			<div className="middle-text__text">
				<i>Publicly Available Information</i>
			</div>
			<div className="middle-text__text">
				<p>
					Please be aware that when You share personal information or otherwise interact in the public areas with other users, such
					information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register
					through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile,
					pictures, and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate
					with You and view Your profile.
				</p>
			</div>

			<h4 className="middle-text__title">Retention of Your Personal Data</h4>
			<div className="middle-text__text">
				<p>
					The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We
					will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are
					required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
				</p>
			</div>

			<div className="middle-text__text">
				<p>
					The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of
					time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally
					obligated to retain this data for longer time periods.
				</p>
			</div>

			<h4 className="middle-text__title">Transfer of Your Personal Data</h4>
			<div className="middle-text__text">
				<p>
					Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the
					parties involved in the processing are located. It means that this information may be transferred to — and maintained on —
					computers located outside of Your state, province, country, or other governmental jurisdiction where the data protection laws may
					differ than those from Your jurisdiction.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					Your acknowledgment of this Privacy Policy followed by Your submission of such information represents Your agreement to that
					transfer.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this
					Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate
					controls in place including the security of Your data and other personal information.
				</p>
			</div>
			<h4 className="middle-text__title">Security of Your Personal Data</h4>
			<div className="middle-text__text">
				<p>
					The security of Your Personal Data is important to Us but remember that no method of transmission over the Internet or method of
					electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot
					guarantee its absolute security.
				</p>
			</div>
			<h4 className="middle-text__title">Your Rights and Choices</h4>
			<div className="middle-text__text">
				<p>
					<i>Do Not Track:</i> Our websites and apps are not designed to respond to "do not track" requests from browsers.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>“Shine the Light” and “Eraser” Laws:</i> Residents of the State of California may request a list of all third parties to which
					We have disclosed certain information during the preceding year for those third parties’ direct marketing purposes.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>California Consumer Privacy Act (CCPA)/California Privacy Rights Act (CPRA):</i> The CCPA, as amended by the CPRA, provides
					California residents and/or their authorized agents with specific rights regarding the collection and storage of their personal
					information.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Your Right to Know:</i> California residents have the right to request that We disclose the following information to You about
					our collection and use of Your personal information over the past twelve (12) months. We may ask You to provide certain
					information to identify Yourself so that We may compare it with Our records in order to verify Your request. Upon verification, We
					will disclose to You:
					<ol>
						<li>The categories of personal information We have collected about You.</li>
						<li>The categories of sources for the personal information We have collected about You.</li>
						<li>The specific pieces of personal information We have collected about You.</li>
						<li>Our business or commercial purpose for collecting Your personal information.</li>
						<li>
							The categories of third parties to whom shared Your personal information, if any, and the categories of personal
							information that We have shared with each third-party recipient.
						</li>
					</ol>
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Your Right to Opt-Out of Sale or Sharing of Personal Information:</i> Under the CCPA, as amended by the CPRA, California
					residents have the right to opt-out of the sale of their personal information and/or the sharing of personal information with
					third parties for the purposes of cross-contextual behavioral advertising or profiling by submitting a request.{' '}
					<strong>
						Please note that We do not sell personal information, including the personal information of any individuals under the age of
						16.
					</strong>
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Your Right to Limit Use of Sensitive Personal Information:</i> California residents have the right to request that we limit Our
					use of any sensitive personal information to those uses, which are necessary to perform the Services or for other business
					purposes under the CCPA, as amended by the CPRA.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Your Right to Delete:</i> California residents have the right to request that We delete any of the personal information
					collected from You and retained by Us, subject to certain exceptions. We may ask You to provide certain information to identify
					Yourself so that We may compare it with Our records in order to verify Your request. Once Your request is verified and We have
					determined that We are required to delete the requested personal information in accordance with the CCPA, as amended by the CPRA,
					We will delete, and direct Our third-party service provides to delete, Your personal information from their records. Your request
					to delete personal information that We have collected may be denied if We conclude it is necessary for Us to retain such personal
					information under one or more of the exceptions listed in the CCPA, as amended by the CPRA.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Your Right to Correct:</i> Under the CCPA, as amended by the CPRA, California residents have the right to request that We
					correct any inaccurate personal information We maintain about You, taking into account the nature of the personal information and
					the purposes for which We are processing such personal information. We will use commercially reasonable efforts to correct such
					inaccurate personal information about You.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					<i>Non-Discrimination:</i> You will not receive any discriminatory treatment by Us for the exercise of Your privacy rights
					conferred by the CCPA, as amended by the CPRA.
				</p>
			</div>
			<div className="middle-text__text">
				<i>Exercising Access and Deletion Rights</i>
			</div>
			<div className="middle-text__text">
				<p>To exercise the access and deletion rights described above, please submit a verifiable consumer request to Us by either:</p>
			</div>
			<div className="middle-text__text">
				<ul>
					<li>
						By email:{' '}
						<a href="mailto:Support@LapofLove.com" className="inline-link">
							Support@LapofLove.com
						</a>
					</li>
					<li>
						By phone:{' '}
						<a href={'tel:855-933-5683'} className="inline-link">
							855-933-5683
						</a>
					</li>
				</ul>
			</div>
			<div className="middle-text__text">
				<p>We may be required to request certain additional information from You in order to verify your request.</p>
			</div>
			<h2>CHILDREN'S PRIVACY</h2>

			<div className="middle-text__text">
				<p>
					Our Service does not address anyone under the age of 13. We do not knowingly collect Personal Data from anyone under the age of
					13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We
					become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We
					take steps to remove that information from Our servers.
				</p>
			</div>
			<h2>NEWSLETTER</h2>

			<div className="middle-text__text">
				<ul>
					<li>
						You can choose to subscribe to Our newsletter by providing Your e-mail address. After you subscribe, we will save your e-mail
						address for the purpose of sending you the newsletter.
					</li>
					<li>
						You can unsubscribe from the newsletter at any time by clicking on the link provided in each newsletter e-mail or by
						contacting us according to the instructions below (Contact Us).
					</li>
				</ul>
			</div>

			<h2>USE OF EXTERNAL TOOLS ON OUR WEBSITE</h2>
			<h4 className="middle-text__title">Google Analytics</h4>
			<div className="middle-text__text">
				<p>The Company has integrated the component Google Analytics (with anonymization function) on this Website.</p>
			</div>
			<div className="middle-text__text">
				<p>
					Google Analytics is a web analytics service. Web analytics is the gathering, collection, and analysis of data about the behavior
					of visitors to websites. Among other things, web analytics services collect data about the websites a user has visited before
					visiting the current website (so-called referrers), which subpages of the website are accessed and how often and for how long a
					subpage is viewed. Such services are mainly used to optimize a website and for the cost-benefit analysis of Internet advertising.
				</p>
			</div>
			<div className="middle-text__text">
				<p>The operator of the Google Analytics component is Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA 94043-1351, USA.</p>
			</div>
			<div className="middle-text__text">
				<p>
					Google Analytics uses cookies. The information generated by the cookie about your use of the Website is usually transmitted to a
					Google server in the USA and stored there. Google might transfer the Personal Data collected via this technical procedure to third
					parties.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					Because IP anonymization is activated on our Website, your IP address will be shortened by Google. On Our behalf, Google will use
					this information to evaluate Your use of the Website, compile reports on Website activity and to provide further services related
					to the Website and internet use to Us. The IP address transferred through your browser to Google Analytics will not be combined
					with other data held by Google.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					In addition, this Website uses the Analytics feature User ID to track interaction data. This User ID will be additionally
					anonymized and encrypted and will not be linked with other data.
				</p>
			</div>
			<div className="middle-text__text">
				<p>If You want to disable cookie storage for Google, you can do so via Your browser settings.</p>
			</div>
			<div className="middle-text__text">
				<p>
					In addition, you may prevent the collection of the data generated by the cookie and related to Your use of the Website (including
					your IP address) by Google as well as the processing of this data by Google by downloading and installing the browser plug-in
					available under the following link:{' '}
					<a href="https://tools.google.com/dlpage/gaoptout?hl=en" className="inline-link">
						https://tools.google.com/dlpage/gaoptout?hl=en
					</a>
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					This browser add-on informs Google Analytics via JavaScript that no data and information about Website visits may be transmitted
					to Google Analytics.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					Further information and Google‘s applicable privacy regulations can be found at{' '}
					<a href="https://policies.google.com/privacy?hl=en" className="inline-link">
						https://policies.google.com/privacy?hl=en
					</a>{' '}
					and{' '}
					<a href="https://marketingplatform.google.com/about/" className="inline-link">
						https://marketingplatform.google.com/about/
					</a>
					. The following link provides a further explanation of Google Analytics https://marketingplatform.google.com/about/.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					Our Website also uses Google Analytics performance reports relating to demographics and interests and reports on Google Display
					Network impressions. You can disable Google Analytics for display advertising and customize the ads on the Google Display Network
					by visiting the ad settings at this link:{' '}
					<a
						href="https://www.google.com/ads/preferences?continue=aHR0cHM6Ly9hZHNzZXR0aW5ncy5nb29nbGUuY29tL2Fub255bW91cw%3D%3D"
						className="inline-link"
					>
						https://www.google.com/ads/preferences?continue=aHR0cHM6Ly9hZHNzZXR0aW5ncy5nb29nbGUuY29tL2Fub255bW91cw%3D%3D
					</a>
					.
				</p>
			</div>
			<h4 className="middle-text__title">Facebook Tracking Pixel</h4>
			<div className="middle-text__text">
				<p>
					Our Service uses Facebook's "tracking pixel." This pixel can be used to track the behavior of users who have been redirected to
					Our Website by clicking on a Facebook and / or Instagram ad. This allows Us to record the effectiveness of Facebook and Instagram
					ads for statistical and market research purposes and, if necessary, to take optimization measures. The tracking of users who have
					landed on our Website after clicking on one of our Facebook and Instagram ads can remain active up to 180 days.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					The data collected in this way is anonymous for us, i.e., we do not see the Personal Data of individual users. However, this data
					is stored and processed by Facebook, which may connect this data to a user’s Facebook account and also use it for its own
					advertising purposes in accordance with its privacy policy.
				</p>
			</div>
			<div className="middle-text__text">
				<p>If You want to disable cookie storage for Facebook, you can do so via Your browser settings.</p>
			</div>
			<h2>LINKS TO OTHER WEBSITES</h2>
			<div className="middle-text__text">
				<p>
					Our Service may contain links to other websites that are not operated by Us. If You click on a third-party link, You will be
					directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or
					services.
				</p>
			</div>
			<h2>CHANGES TO THIS PRIVACY POLICY</h2>
			<div className="middle-text__text">
				<p>
					We may update Our Privacy Policy from time to time. We will notify You via email and/or a prominent notice on Our Service prior to
					the change becoming effective and update the “Last updated” date at the top of this Privacy Policy.
				</p>
			</div>
			<div className="middle-text__text">
				<p>
					You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they
					are posted on this page.
				</p>
			</div>

			<h2>CONTACT US</h2>
			<div className="middle-text__text">
				<p>If you have any questions about this Privacy Policy, You can contact us:</p>
			</div>
			<div className="middle-text__text">
				<ul>
					<li>
						By email:{' '}
						<a href="mailto:Support@LapofLove.com" className="inline-link">
							Support@LapofLove.com
						</a>
					</li>
					<li>
						By phone:{' '}
						<a href={'tel:855-933-5683'} className="inline-link">
							855-933-5683
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default withSeo(PrivacyPolicy, state => state.privacyPolicyPage, 'privacyPolicyPage', 'policies/privacy-policy');
